/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  calendarios: [],
  fechaSeleccionada: "",
  isVisibleDetalle: false,
  diaSeleccionado: "",
  horaSeleccionado: "",
  id_hora: "",
  pedido: [],
  loading: false,
  aforoxdia: [],
  aforoxhora: [],
  horario: [],
  estacion: [],
  dia_detalle: [],
  loading2: false,
  id: [],
  id_old: [],
  id_aforoxdia: "",
  reserva_existe: false
};
